export const DOCUMENT_UPLOAD_MAX_FILE_BYTES = 100 * 1024 * 1024;

export const getUploadSelectionError = (files: ReadonlyArray<Pick<File, 'size'>>) => {
  if (files.length > 20) return 'batchFileCountLimit' as const;
  if (files.some(file => file.size > DOCUMENT_UPLOAD_MAX_FILE_BYTES)) return 'singleFileSizeLimit' as const;
  return null;
};
